import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    load2048Status: 'idle',
    load2048Error: undefined as any,
    save2048Status: 'idle',
    save2048Error: undefined as any,
    update2048Status: 'idle',
    update2048Error: undefined as any,
    process2048Status: 'idle',
    process2048Error: undefined as any,

    rechnungeingangsbuchList: [] as any[],
    currentRechnungeingangsbuch: undefined as any,
    processedRechnungeingangsbuch: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,
}

export const load2048 = createAsyncThunk('rechnungeingangsbuchSlice/load2048', async (selectedItem: any, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/CIxReBuchScrnVarsBuvorgangRebuIdToJson/?BuvorgangRebuId=${selectedItem.BUVORGANGREBU_ID}`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})
export const save2048 = createAsyncThunk('rechnungeingangsbuchSlice/save2048', async (rechnungeingangsbuch: any, { rejectWithValue }: any) => {
    const res = await client.put(`/api/ixweb/CIxReBuchScrnVarsSaveBuvorgangRebuFromJson/`, prepareData({ data: rechnungeingangsbuch }))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return rechnungeingangsbuch
        }
    } else {  // backend response
        return res.data
    }
})
export const update2048 = createAsyncThunk('rechnungeingangsbuchSlice/update2048', async (rechnungeingangsbuch: any, { rejectWithValue }: any) => {
    const res = await client.put(`/api/ixweb/CIxReBuchScrnVarsSaveBuvorgangRebuFromJson/`, prepareData({ data: rechnungeingangsbuch }))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return rechnungeingangsbuch
        }
    } else {  // backend response
        return res.data
    }
})
export const process2048 = createAsyncThunk('rechnungeingangsbuchSlice/process2048', async (data: any, { rejectWithValue }: any) => {
    const res = await client.put(`/api/ixweb/CIxReBuchScrnVarsProcessBuvorgangRebuFromJson/`, prepareData(data))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed' || res.data.messages.error.length) {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})

const RechnungeingangsbuchSlice = createSlice({
    name: 'rechnungeingangsbuchSlice',
    initialState,
    reducers: {
        resetload2048: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.load2048Error = undefined
        },
        resetload2048Error: (state) => {
            state.load2048Error = undefined
        },
        resetsave2048: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.save2048Error = undefined
        },
        resetsave2048Error: (state) => {
            state.save2048Error = undefined
        },
        resetupdate2048: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.update2048Error = undefined
        },
        resetupdate2048Error: (state) => {
            state.update2048Error = undefined
        },
        resetprocess2048: (state) => {
            state.processedRechnungeingangsbuch = undefined
            state.process2048Error = undefined
        },
        resetprocess2048Error: (state) => {
            state.process2048Error = undefined
        },
        removeFromRechnungeingangsbuchListById: (state, action) => {
            state.rechnungeingangsbuchList = state.rechnungeingangsbuchList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(load2048.pending, (state) => {
            state.load2048Status = 'pending'
            state.load2048Error = undefined
        })
        builder.addCase(load2048.fulfilled, (state, action) => {
            state.load2048Status = 'idle'

            const newItem = Array.isArray(action.payload) ? action.payload[0] : action.payload
            state.currentRechnungeingangsbuch = newItem
        })
        builder.addCase(load2048.rejected, (state, action) => {
            state.load2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.load2048Error = action.error.message
            } else {
                state.load2048Error = action.payload
            }
        })

        builder.addCase(save2048.pending, (state) => {
            state.save2048Status = 'pending'
            state.save2048Error = undefined
        })
        builder.addCase(save2048.fulfilled, (state, action) => {
            state.save2048Status = 'idle'

            const newItem = Array.isArray(action.payload) ? action.payload[0] : action.payload
            state.currentRechnungeingangsbuch = newItem
        })
        builder.addCase(save2048.rejected, (state, action) => {
            state.save2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.save2048Error = action.error.message
            } else {
                state.save2048Error = action.payload
            }
        })

        builder.addCase(update2048.pending, (state) => {
            state.update2048Status = 'pending'
            state.update2048Error = undefined
        })
        builder.addCase(update2048.fulfilled, (state, action) => {
            state.update2048Status = 'idle'

            const newItem = Array.isArray(action.payload) ? action.payload[0] : action.payload
            state.currentRechnungeingangsbuch = newItem
        })
        builder.addCase(update2048.rejected, (state, action) => {
            state.update2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.update2048Error = action.error.message
            } else {
                state.update2048Error = action.payload
            }
        })

        builder.addCase(process2048.pending, (state) => {
            state.process2048Status = 'pending'
            state.process2048Error = undefined
        })
        builder.addCase(process2048.fulfilled, (state, action) => {
            state.process2048Status = 'idle'

            const newItem = Array.isArray(action.payload) ? action.payload[0] : action.payload
            state.processedRechnungeingangsbuch = newItem
        })
        builder.addCase(process2048.rejected, (state, action) => {
            state.process2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.process2048Error = action.error.message
            } else {
                state.process2048Error = action.payload
            }
        })

    }
})

export const {
    resetload2048,
    resetload2048Error,
    resetsave2048,
    resetsave2048Error,
    resetupdate2048,
    resetupdate2048Error,
    resetprocess2048,
    resetprocess2048Error,
    removeFromRechnungeingangsbuchListById,
    setFilterValues,
    setFilterLookupValue,
} = RechnungeingangsbuchSlice.actions
export default RechnungeingangsbuchSlice.reducer
